module.exports = __webpack_public_path__ + "static/media/school-compass.226c3389.svg";